export function buildActorGenerationAudienceRequests(audiences, selectedAudienceIds, actorCount) {
  const selectedIds = selectedAudienceIds instanceof Set
    ? selectedAudienceIds
    : new Set(selectedAudienceIds || []);

  return audiences
    .filter((audience) => selectedIds.has(audience.id))
    .map((audience) => ({
      audienceId: audience.id,
      audienceName: audience.name,
      audienceDescription: audience.description || '',
      acquisitionChannels: Array.isArray(audience.acquisitionChannels)
        ? audience.acquisitionChannels
        : [],
      actorCount,
    }));
}

export function getAudienceAcquisitionChannelsForDisplay(audience) {
  if (!audience || !Array.isArray(audience.acquisitionChannels)) {
    return [];
  }

  return audience.acquisitionChannels
    .map((channel, index) => {
      if (!channel || typeof channel !== 'object') return null;
      const label = String(channel.label || channel.channel || '').trim();
      const id = String(channel.channel || label || `channel-${index + 1}`).trim();
      const percentage = Number(channel.percentage);
      if (!label || !Number.isFinite(percentage)) return null;

      const fit = channel.fit === 'primary' || channel.fit === 'secondary' || channel.fit === 'supporting'
        ? channel.fit
        : 'supporting';

      return {
        key: `${id}-${index}`,
        label,
        percentage,
        fit,
        isPrimary: fit === 'primary',
        rationale: typeof channel.rationale === 'string' ? channel.rationale : '',
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      if (a.isPrimary !== b.isPrimary) return a.isPrimary ? -1 : 1;
      return b.percentage - a.percentage;
    });
}
